import script from "./ProductTagItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductTagItem.vue?vue&type=script&setup=true&lang=js"

import "./ProductTagItem.vue?vue&type=style&index=0&id=3d46aaf4&lang=scss"

const __exports__ = script;

export default __exports__